import * as Yup from 'yup'

export const datasetFormik = () => {
  const INITIAL_FORMIK_STATE = {
    code: '',
    descripcion: '',
    userId: '',
    tenantId: '',
    startDate: null,
    endDate: null,
  }

  const ITEMS_FORMIK = [
    { x: 6, name: 'code', label: 'Código de acceso' },
    { x: 6, name: 'descripcion', label: 'Descripción de la prueba' },
  ]

  const FORM_VALIDATION = Yup.object().shape({
    code: Yup.string().required('El código es requerido').max(50, 'Máximo 50 caracteres'),
    descripcion: Yup.string().max(200, 'Máximo 200 caracteres'),
    userId: Yup.string().required('El usuario designado es requerido'),
    tenantId: Yup.number()
      .typeError('Selecciona un tenant')
      .required('El tenant es requerido')
      .positive()
      .integer(),
    startDate: Yup.date()
      .typeError('Fecha inválida')
      .required('La fecha de inicio es requerida')
      .nullable(),
    endDate: Yup.date()
      .typeError('Fecha inválida')
      .required('La fecha de fin es requerida')
      .nullable()
      .min(Yup.ref('startDate'), 'La fecha de fin debe ser posterior a la de inicio'),
  })

  return { INITIAL_FORMIK_STATE, ITEMS_FORMIK, FORM_VALIDATION }
}
